/**
 * ⌘K: "aftercare sheets" finds the practice's Standard aftercare sheets
 * switch on Practice settings. US only, like the switch itself, and only for
 * someone who can open that page.
 *
 * Registered once the session is signed in, because that is when the realm is
 * known (`stores/auth` stores it from /auth/me before it marks the session
 * authenticated).
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { FileText } from 'lucide-react'
import { commandRegistry } from '@/utils/commandRegistry'
import { useAuthStore } from '@/stores/auth'
import { getRealm } from '@/lib/realm'
import { regionalText } from '@/lib/regional-copy'

export const AFTERCARE_SHEETS_COMMAND_ID = 'nav-practice-aftercare-sheets'
const PATH = '/manage/clinic/settings'

export function useAftercareSheetsCommand(): void {
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  useEffect(() => {
    if (!isAuthenticated || getRealm() !== 'us') return
    return commandRegistry.register({
      id: AFTERCARE_SHEETS_COMMAND_ID,
      label: 'Standard aftercare sheets',
      subtitle: regionalText('Clinic settings'),
      icon: FileText,
      path: PATH,
      permission: 'settings:manage',
      keywords: ['aftercare', 'aftercare sheets', 'standard aftercare', 'aftercare templates', 'templates'],
      category: 'navigation',
      action: () => navigate(PATH),
    })
  }, [isAuthenticated, navigate])
}
